Vue.component('star-rating', {
    props: {
        rating: Number,
    },
    data() {
        return {
            hoverRating: null,
        }
    },
    methods: {
        hover(rating) {
            this.hoverRating = rating 
        },
        blur() {
            this.hoverRating = null
        },
        set(rating) {
            this.$emit('change-review-rating', rating);
        }
    }
});